/**
 * Weather Exception Tracker - Main Entry Point
 * 
 * This file registers the WeatherExceptionTracker component following the
 * same pattern as other main-*.js files in the project.
 * 
 * The component is registered in window.VcAvailableComponents and can be
 * loaded using the standard VcComponents loader pattern in HTML pages.
 */

import WeatherExceptionTracker from './components/weatherexceptions/WeatherExceptionTracker.vue';

// Import styles
import './scss/styles.scss';

import { createApp } from 'vue';

let VcComponentLoader = (function() {
  console.log("Starting VcWeatherExceptionsComponentLoader...");
  
  const COMPONENTS = {
    'WeatherExceptionTracker': WeatherExceptionTracker,
  };

  // Merge with existing available components or create new
  window.VcAvailableComponents = (window.VcAvailableComponents && { ...window.VcAvailableComponents, ...COMPONENTS }) || COMPONENTS;

})();
